  import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
  import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

  export const vsObjectName = "machineLeaseCategory";

  const url = "/api/machines/MachineLeaseCategory";

  export const machineLeaseCategoryLookupConfig = simpleLookupConfig(
    vsLookupManagementServiceProviderName,
    {
      name: vsObjectName,
      nameSingular: "Lease Category",
      url,
    }
  );
